const scrollToElement = (options) => {

    if (typeof options !== 'object') {
        throw "ScrollToElement: Invalid configuration options";
    }

    if (typeof options.scrollToThis == 'undefined') {
        throw "ScrollToElement: Invalid configuration options";
    }

    const defaultConfig = {
        thisWillScroll: '#main-container',
        scrollToThis: undefined,
        additionalPadding: '15',
        duration: 1000
    };

    let config = $.extend(true, defaultConfig, options);

    let $thisWillScroll = $(config.thisWillScroll);
    let thisWillScrollCurrentScrollPosition = $thisWillScroll.scrollTop();
    let thisWillScrollOffsetTop = $thisWillScroll.offset().top
    let scrollToThisOffsetTop = $(config.scrollToThis).offset().top;
    let scrollToThisPosition = scrollToThisOffsetTop - thisWillScrollOffsetTop + thisWillScrollCurrentScrollPosition - config.additionalPadding;

    $thisWillScroll.animate({
        scrollTop: scrollToThisPosition
    }, config.duration);
}

module.exports = scrollToElement;


// WEBPACK FOOTER //
// ./shared/scripts/scrollToElement.js